export class TeardownReport {
  optixID: number;
  fileName: string;
  fileSize: number;
  companyPartNumber: string;
  poSONum: string;
  vendor: string;
  teardownDate: Date;
  removalDate: Date;
  fsc: string;
  repairType: string;
}
